import React from 'react'
import PropTypes from 'prop-types'

import ExternalImageHostRoute from './ExternalImageHostRoute'
import UploadImageCreativeRoute from './UploadImageCreativeRoute'
import ExistingImagesLibraryRoute from './ExistingImagesLibraryRoute'

import { IMAGE_UPLOAD_TYPE, IMAGE_EXTERNAL_HOST_TYPE, IMAGE_EXISTING_LIBRARY_TYPE } from '../../fields'

const ImageRoutes = ({ selectedRoute, ...otherProps }) => {
  switch (selectedRoute) {
    case IMAGE_UPLOAD_TYPE:
      return <UploadImageCreativeRoute {...otherProps} />
    case IMAGE_EXTERNAL_HOST_TYPE:
      return <ExternalImageHostRoute {...otherProps} />
    case IMAGE_EXISTING_LIBRARY_TYPE:
    default:
      return <ExistingImagesLibraryRoute />
  }
}

ImageRoutes.propTypes = {
  selectedRoute: PropTypes.string.isRequired
}

export default ImageRoutes
